import { prettyTx } from '@sovryn/ui';
import { BOB_CHAIN_ID, RSK_CHAIN_ID } from '../config/chains';
import { findAsset, findAssetByAddress } from '../utils/asset';
export const getTokenDisplayName = (token, chainId = RSK_CHAIN_ID) => { var _a; return ((_a = findAsset(token, chainId)) === null || _a === void 0 ? void 0 : _a.symbol) || token.toUpperCase(); };
export const getTokenDisplayNameByAddress = (address, chainId = BOB_CHAIN_ID, fallbackPrettified = true) => {
    var _a;
    return ((_a = findAssetByAddress(address, chainId)) === null || _a === void 0 ? void 0 : _a.symbol) ||
        (fallbackPrettified ? prettyTx(address) : address);
};
